import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Trash2 } from 'lucide-react';
import { Field } from '../ui';

const RequirementLine = ({ item, number, sample, setQuantity, removeItem }) => (
  <div className="rfq-line" data-testid={`rfq-line-${item.product_id}`}>
    <span className="line-number">{String(number).padStart(2, '0')}</span>
    <div><strong>{item.name}</strong><small>{item.sku} · {item.supplier_name}</small><small>MOQ {item.moq} {item.unit}</small></div>
    <Field id={`rfq-qty-${item.product_id}`} label={item.unit} type="number"
      min={sample ? 1 : item.moq} step="1" required value={item.quantity}
      onChange={event => setQuantity(item.product_id, Number(event.target.value))} />
    <button type="button" className="icon-button" data-testid={`rfq-remove-${item.product_id}`}
      aria-label={`Remove ${item.name}`} onClick={() => removeItem(item.product_id)}><Trash2 size={17} /></button>
  </div>
);

export const RequirementFields = ({ draft, sample, setSample, setQuantity, removeItem }) => <>
  <div className="subheading"><h2>Products in your request</h2>
    <Link to="/catalog" data-testid="rfq-add-more">Add more products <ArrowRight size={14} /></Link>
  </div>
  <div className="rfq-lines">{draft.map((item, index) => <RequirementLine key={item.product_id}
    item={item} number={index + 1} sample={sample} setQuantity={setQuantity} removeItem={removeItem} />)}</div>
  <label className="checkbox-label"><input data-testid="rfq-sample" type="checkbox" checked={sample}
    onChange={event => setSample(event.target.checked)} />This is a sample request (MOQ may be waived by the supplier)</label>
</>;